module.exports = __webpack_public_path__ + "img/road-trip-1.cf4b3468.jpg";